import { ApiLek, ApiLekDateRangePossibilities, ApiLekSponsor } from '../api/api-types/lek.api';
import { AppCreateLek, Lek, LekSponsor } from '../api/app-types/lek.app';
import { PaginatedResponse } from '../shared/pagination/paginated-response';

export const mockLekPage: PaginatedResponse<Lek> = {
	totalEntities: 2,
	range: 5,
	offset: 1,
	entities: [
		{
			id: 1,
			startDate: new Date(2024, 0, 1),
			endDate: new Date(2024, 0, 10),
			result: 'Ergebnis A',
			categoryAssistance: {
				id: 11,
				description: 'Assistenz A',
				canEnterDuration: false,
			},
			isHandledByExternalSponsor: false,
		},
		{
			id: 2,
			result: '',
			categoryAssistance: {
				canEnterDuration: true,
				id: 12,
				description: 'Assistenz B',
			},
			isHandledByExternalSponsor: true,
		},
	],
};

export const mockEmptyLekPage: PaginatedResponse<Lek> = {
	totalEntities: 0,
	range: 5,
	offset: 0,
	entities: [],
};

export const mockApiLekPage: PaginatedResponse<ApiLek> = {
	entities: [
		{
			id: 1,
			startDate: '2024-01-01',
			endDate: '2024-02-01',
			result: 'Result A',
			workplace: {
				id: 10,
				name: 'Workplace A',
				cityDistrict: {},
				contactPoints: [],
				institutionPersons: [],
				isMainInstitution: false,
			},
			categorySponsor: {
				id: 7,
				description: 'Sponsor A',
			},
			categoryAssistance: {
				id: 11,
				description: 'Category A',
			},
			isHandledByExternalSponsor: true,
		},
	],
	offset: 0,
	range: 10,
	totalEntities: 1,
};

export const mockLekDateRangeResponse: ApiLekDateRangePossibilities = {
	validStartDateRange: { min: '2024-01-01', max: '2024-12-31' },
	validEndDateRange: { min: '2024-01-02', max: '2025-01-31' },
};

export const mockAppCreateLek: AppCreateLek = {
	startDate: new Date('2024-01-01T00:00'),
	endDate: new Date('2024-01-10T00:00'),
	result: 'Ergebnis',
	categoryAssistanceId: 5,
	assignmentId: 9,
	appCreateLekDynamicFields: {
		sponsorId: 2,
		workplaceId: 3,
		isHandledByExternalSponsor: true,
	},
};

export const mockLekSponsorPage: PaginatedResponse<LekSponsor> = {
	totalEntities: 2,
	range: 5,
	offset: 0,
	entities: [
		{
			id: 1,
			description: 'Sponsor A',
		},
		{
			id: 2,
			description: 'Sponsor B',
		},
	],
};

export const mockApiLekSponsorPage: PaginatedResponse<ApiLekSponsor> = {
	totalEntities: 2,
	range: 5,
	offset: 0,
	entities: [
		{
			id: 1,
			description: 'Sponsor A',
		},
		{
			id: 2,
			description: 'Sponsor B',
		},
	],
};
